import axios from 'axios'

export function deleteAllReportTransactions(sessionId: string): Promise<any> {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: process.env.REACT_APP_CONNECT_API_URL + '/report/transactions/deleteAll',
      headers: {
        'x-api-key': process.env.REACT_APP_CONNECT_API_KEY,
      },
      data: {
        sessionId,
      },
    })
      .then((res: any) => {
        resolve(res)
      })
      .catch((err: any) => {
        console.error(err)
      })
  })
}
